/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';
import type { InternalApiCaseAssignment } from './InternalApiCaseAssignment';
import {
    InternalApiCaseAssignmentFromJSON,
    InternalApiCaseAssignmentFromJSONTyped,
    InternalApiCaseAssignmentToJSON,
    InternalApiCaseAssignmentToJSONTyped,
} from './InternalApiCaseAssignment';
import type { InternalApiCaseDetails } from './InternalApiCaseDetails';
import {
    InternalApiCaseDetailsFromJSON,
    InternalApiCaseDetailsFromJSONTyped,
    InternalApiCaseDetailsToJSON,
    InternalApiCaseDetailsToJSONTyped,
} from './InternalApiCaseDetails';
import type { InternalApiCaseAssignedStatus } from './InternalApiCaseAssignedStatus';
import {
    InternalApiCaseAssignedStatusFromJSON,
    InternalApiCaseAssignedStatusFromJSONTyped,
    InternalApiCaseAssignedStatusToJSON,
    InternalApiCaseAssignedStatusToJSONTyped,
} from './InternalApiCaseAssignedStatus';

/**
 * 
 * @export
 * @interface InternalApiCase
 */
export interface InternalApiCase {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCase
     */
    handle: string;
    /**
     * 
     * @type {InternalApiCaseDetails}
     * @memberof InternalApiCase
     */
    details: InternalApiCaseDetails;
    /**
     * 
     * @type {InternalApiCaseAssignedStatus}
     * @memberof InternalApiCase
     */
    assignedStatus: InternalApiCaseAssignedStatus;
    /**
     * 
     * @type {InternalApiCaseAssignment}
     * @memberof InternalApiCase
     */
    assignment?: InternalApiCaseAssignment;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiCase
     */
    createdBy: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCase
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the InternalApiCase interface.
 */
export function instanceOfInternalApiCase(value: object): value is InternalApiCase {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('assignedStatus' in value) || value['assignedStatus'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function InternalApiCaseFromJSON(json: any): InternalApiCase {
    return InternalApiCaseFromJSONTyped(json, false);
}

export function InternalApiCaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCase {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'],
        'details': InternalApiCaseDetailsFromJSON(json['details']),
        'assignedStatus': InternalApiCaseAssignedStatusFromJSON(json['assignedStatus']),
        'assignment': json['assignment'] == null ? undefined : InternalApiCaseAssignmentFromJSON(json['assignment']),
        'createdBy': InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function InternalApiCaseToJSON(json: any): InternalApiCase {
    return InternalApiCaseToJSONTyped(json, false);
}

export function InternalApiCaseToJSONTyped(value?: InternalApiCase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'details': InternalApiCaseDetailsToJSON(value['details']),
        'assignedStatus': InternalApiCaseAssignedStatusToJSON(value['assignedStatus']),
        'assignment': InternalApiCaseAssignmentToJSON(value['assignment']),
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'createdAt': value['createdAt'].toISOString(),
    };
}

